import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import DocumentService from '@/shared/services/DocumentService';
import EnumCacheService from '@/shared/services/EnumCacheService';
import EditableAutoComplete from '@/shared/components/editable/EditableAutoComplete';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';

const messages = defineMessages({
  StartTypingToSearch: 'Start typing to search',
});

const EditableDocumentTypeSelect = ({ value, onChange, disabled = false, required = false }) => {
  const intl = useIntl();
  const [items, setItems] = useState([]);
  useEffect(() => {
    let cancelled = false;
    const promise = Promise.all([
      EnumCacheService.getTranslated('documentType', intl, false),
      DocumentService.getForbiddenDocumentTypes(),
    ]).then(([documentTypes, forbiddenTypes]) => {
      if (cancelled) return;
      const filteredItems =
        forbiddenTypes && forbiddenTypes.length > 0
          ? documentTypes.filter(x => !forbiddenTypes.includes(x.key))
          : documentTypes;
      setItems(filteredItems.map(x => ({ ...x, key: x.id })));
    });

    return () => {
      cancelled = true;
    };
  }, []);
  const getDisplayValue = useCallback(
    documenttype => {
      if (!documenttype && documenttype !== 0) return null;
      const value = intl.formatMessage(listItemMsg('documenttype', documenttype.key));
      return <span title={value}>{value}</span>;
    },
    [intl],
  );

  const selectedDocumentType = value && !!items ? items.find(x => x.key === value) : null;

  return (
    <EditableAutoComplete
      displayValue={getDisplayValue}
      items={items}
      placeholder={intl.formatMessage(messages.StartTypingToSearch)}
      onChange={item => onChange(item?.id)}
      mode="edit"
      value={selectedDocumentType}
      showAll
      required={required}
      disabled={disabled}
      canClear={!required}
      submitOnChange
    />
  );
};

export default EditableDocumentTypeSelect;
